<div class="add-subfolder--container">
  <div class="title">{{data.title || 'Rename Institution'}}</div>

  <div class="add-input">
    <div class="subfolder-name">{{data.subfolderName || 'Institution Name'}}</div>
    <input style="width: 100% !important" name="institutionName" type="text" maxlength="40" [(ngModel)]="institutionName" (input)="onNameInput($event)"/>
  </div>

  <div class="action">
    <button class="cancel-button mr-2" (click)="closeDialog()">Cancel</button>
    <button [class]="!institutionName ? 'disable-rename-btn rename-btn' : 'rename-btn'" [disabled]="!institutionName"
      (click)="confirmDialog()">Rename</button>
  </div>
</div>